import React, { Component } from 'react'
import { connect } from 'react-redux'

import styled from 'styled-components'

import { Link } from 'react-router-dom'

// import './Sidebar.css'
import Bell from './visuals/Bell'
import SidebarCategory from './SidebarCategory'

const VisualSidebar = styled.aside`
  position: fixed;
  left: 0px;
  transition: transform 500ms ease-out;

  background-color: #181818;
  width: 250px;
  color: #C4C4C4;

  ${props => !props.isOpen && `
    transform: translate(-250px, 0px);
  `}


  h1 {
    display: inline-block;
    margin: 0;

    font-family: 'Source Sans Pro';
    font-style: bold;
    font-size: 16px;
    line-height: 20px;
    color: #CCA633;
  }

  .top {
    padding: 16px 24px;
    box-sizing: border-box;
    height: 56px;
  }

  .bell {
    float: right;
  }

  .bottom {
    padding: 39px 24px;
    /* Subtract extra the space on top (56px) and bottom (100px) */
    height: calc(100vh - 56px - 100px);
    box-sizing: border-box;
    overflow-y: auto;

    li {
      margin: 8px 0px;
    }

    li:nth-child(1) {
      margin-top: 0px;
    }

    nav li {
      font-family: 'Source Sans Pro';
      font-size: 14px;
      font-weight: bold;
      line-height: 18px;
      color: #C4C4C4;
    }

    .categories {
      margin: 32px 0px;
    }

    .categories > ul > li {
      margin: 16px 0;
    }
  }
`

const mapStateToProps = (state) => ({
  isOpen: state.sidebar.isOpen
})

// Sidebar is a container component
// VisualContainer is a presentational component

class Sidebar extends Component {
  render() {
    return (
      <VisualSidebar isOpen={this.props.isOpen}>
        <div className="top">
          <h1>UA Bible</h1>
          <Bell width="16" height="20" />
        </div>

        <div className="bottom">
          <nav>
            <ul>
              <li><Link to='/'>Homepage</Link></li>
              <li><a href='https://www.gvm.website/get-involved'>Contact Us</a></li>
              <li><a href='https://www.gvm.website/make-a-donation'>Donate</a></li>
            </ul>
          </nav>

          <div className="categories">
            <ul>
              <SidebarCategory title='Old Testament' books={[
                'Genesis',
                'Exodus',
                'Leviticus',
                'Numbers',
                'Deuteronomy',
                'Joshua',
                'Judges',
                'Ruth',
                '1 Samuel',
                '2 Samuel',
                '1 Kings',
                '2 Kings',
                '1 Chronicles',
                '2 Chronicles',
                'Ezra',
                'Nehemiah',
                'Esther',
                'Job',
                'Psalm',
                'Proverbs',
                'Ecclesiastes',
                'Song of Songs',
                'Isaiah',
                'Jeremiah',
                'Lamentations',
                'Ezekiel',
                'Daniel',
                'Hosea',
                'Joel',
                'Amos',
                'Obadiah',
                'Jonah',
                'Micah',
                'Nahum',
                'Habakkuk',
                'Zephaniah',
                'Haggai',
                'Zechariah',
                'Malachi',
              ]} />
              <SidebarCategory title='New Testament' books={[
                'Matthew',
                'Mark',
                'Luke',
                'John',
                'Acts',
                'Romans',
                '1 Corinthians',
                '2 Corinthians',
                'Galatians',
                'Ephesians',
                'Philippians',
                'Colossians',
                '1 Thessalonians',
                '2 Thessalonians',
                '1 Timothy',
                '2 Timothy',
                'Titus',
                'Philemon',
                'Hebrews',
                'James',
                '1 Peter',
                '2 Peter',
                '1 John',
                '2 John',
                '3 John',
                'Jude',
                'Revelation'
              ]} />
            </ul>
          </div>

        </div>
      </VisualSidebar>
    )
  }
}

Sidebar = connect(
  mapStateToProps,
  null,
  null,
  {
    pure: false
  }
)(Sidebar)

export default Sidebar



// WEBPACK FOOTER //
// ./src/components/Sidebar.js